import { useParams } from "@bcm-dev/bcms-vite";
import PageContainer from "components/shared/containers/PageContainer";
import BottomNavWrapper from "components/shared/wrappers/BottomNavWrapper";
import React from "react";
/**
 * @function NoFooter
 * @returns {React.Component}
 * @exported true
 * @description Serves as a page component to allow us to route from MABI23 specific pages to ABI22 pages.
 */
export default function NoFooter(props) {
  const {page} = useParams();
  const setPage = page !== undefined ? page : props.page === undefined ? "accountSummary":props.page;
  return (
    <PageContainer>
      <BottomNavWrapper page = {setPage} hideNav={true}/>
    </PageContainer>
   
  );
}